/**
 * Setting class
 */
export class Setting {
  id?: number;
  name?: string;
  scope?: string;
  value?: string;
  description?: string;
  language?: string;
  version?: number;

  /**
   * Constructor
   * @param id Id of setting
   * @param name Name of setting
   * @param scope Scope - Can be BRAND, GLOBAL, PRODUCT
   * @param value Value of setting
   * @param description Description for setting.
   * @param language Language IE. EN ES
   * @param version Version of setting
   */
  constructor(id : number, name : string, scope : string, value : string, description : string, language : string, version : number) {
    this.id = id;
    this.name = name;
    this.scope = scope;
    this.value = value;
    this.description = description;
    this.language = language;
    this.version = version;
  }
}
